<template>
  <span
    :class="
      !(
        facetCounts &&
        facetCounts[facetName] &&
        facetCounts[facetName][value.id] > 0
      )
        ? 'text-grey'
        : ''
    "
    >{{ value.abbreviated_name || value.name }} ({{
      get(facetCounts, `${facetName}.${value.id}`, 0)
    }})
  </span>
</template>

<script setup>
import get from 'lodash.get'

defineProps({
  facetCounts: {
    required: true,
    type: Object
  },
  facetName: {
    required: true,
    type: String
  },
  value: {
    type: Object,
    required: true
  }
})
</script>
